import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "flex-1"
};
const _hoisted_2 = {
  key: 0,
  class: "flex-center"
};
import Icon from "@/modules/vue/components/Icon.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'NavBarMenuItem',
  props: {
    to: null,
    icon: null,
    label: null,
    push: {
      type: Boolean
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_RouterLink = _resolveComponent("RouterLink");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_RouterLink, {
        to: __props.to,
        "active-class": "text-green-600 font-bold",
        replace: !__props.push
      }, {
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {}, () => [__props.icon || _ctx.$slots.icon ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_renderSlot(_ctx.$slots, "icon", {}, () => [_createVNode(Icon, {
          icon: __props.icon
        }, null, 8, ["icon"])])])) : _createCommentVNode("", true), _createElementVNode("div", {
          class: _normalizeClass({
            'text-sm': !!__props.icon
          })
        }, _toDisplayString(__props.label), 3)])]),
        _: 3
      }, 8, ["to", "replace"])]);
    };
  }
});